import defaultUser from '../utils/default-user';
import GlobalParams from '../helpers/GlobalParams.js';
import axios from 'axios';

export async function signIn(email, password, is_group_client_contact_person) {

  try {
    // Send request using axios
    const response = await axios.post(
      GlobalParams.LoginApiUrlPrefixV2 + 'login-as-cp',
      {
        'is_group_client_contact_person': is_group_client_contact_person,
        'email': email,
        'password': password,
      }, {
      headers: {
        'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
        'Content-Type': 'multipart/form-data'
      }
    });

    if (response.status === 200) {
      //service.setClientStore(response.data.data);
      GlobalParams.UserEmail = email;
      if (GlobalParams.IsClientLoggedIn) {
        GlobalParams.ContactPersonId = response.data.data.Id;
        GlobalParams.PopFundAccessLevelId = response.data.data.PopFundAccessLevelId;
      } else {
        console.log("Intermediary ID is: "+response.data.data.Intermediary);
        GlobalParams.ContactPersonId = response.data.data.Id;
        GlobalParams.IntermediaryId = response.data.data.Intermediary;
      }

      //save the access token 
      
      let access_token = response.data.access_token;
      
      //TODO- save in localstorage
      // Save the access token in localStorage, 
      localStorage.setItem('isLoggedIn', '1');
      localStorage.setItem('email', email);
      localStorage.setItem('IsClientLoggedIn', GlobalParams.IsClientLoggedIn);
      localStorage.setItem('PopFundAccessLevelId', GlobalParams.PopFundAccessLevelId);
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('bearer_token', GlobalParams.bearerToken);

      GlobalParams.ClientId = response.data.data.Client;
      
    }
    //service.setClientStore(response.data.data);
    return {
      isOk: response.status === 200,
      data: { email: email },
    };
  } catch (error) {
    return {
      isOk: false,
      //message: "Authentication failed",
      message: error.response.data.message,
    };
  }
}

export async function getUser() {
  // Retrieve the access token from localStorage
 
  let access_token = localStorage.getItem('access_token');
 
  let bearer_token = localStorage.getItem('bearer_token');
  let email = localStorage.getItem('email');
  GlobalParams.bearerToken = bearer_token;
  GlobalParams.IsClientLoggedIn = (localStorage.getItem('IsClientLoggedIn') === 'true');

  try {
    if (access_token === undefined || access_token === "undefined" || access_token === "" ||
     access_token === null) {
      return {
        isOk: false,
        //data: defaultUser,
      };
    }
    // Send request to the backened
    const response = await axios.get(
      GlobalParams.LoginApiUrlPrefixV2 + 'get-current-user?accessToken=' + access_token,
      {
        headers: {
          Authorization: `Bearer ${bearer_token}`
        }
      }
    );

    if (response.status === 200) {
      //service.setClientStore(response.data.data);
      GlobalParams.UserEmail = email;
      localStorage.setItem('PopFundAccessLevelId', response.data.data.PopFundAccessLevelId);
      if (GlobalParams.IsClientLoggedIn) {
        GlobalParams.ContactPersonId = response.data.data.Id;
        GlobalParams.PopFundAccessLevelId = response.data.data.PopFundAccessLevelId;
      } else {
        GlobalParams.ContactPersonId = response.data.data.Id;
        GlobalParams.IntermediaryId = response.data.data.Intermediary;
      }

      GlobalParams.ClientId = response.data.data.Client;
    }

    return {
      isOk: response.status === 200,
      data: { email: email },
    };
  }
  catch {
    return {
      isOk: false
    };
  }


  // try {
  //   // Send request to the backend using axios
  //   //const response = await axios.get('your_getuser_endpoint');

  //   return {
  //     isOk: false,
  //     data: defaultUser,
  //   };
  // } catch (error) {
  //   return {
  //     isOk: false,
  //   };
  // }
}

export async function createAccount(email, password, otp) {
  /*try {
    // Send request
    console.log(email, password);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to create account"
    };
  }*/
  try {
    // Send request using axios
    const response = await axios.post(
      GlobalParams.LoginApiUrlPrefixV2 + 'create-cp-password',
      {
        email: email,
        otp: otp,
        password: password,
        confirm_password: password
      },
      {
        headers: {
          Authorization: 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
        }
      }
    );

    return response;
    /*if (response.status === 200) {
      console.log(response);
      //navigate to login page
      navigate('/login');
    } else {
      notify("Not a Valid OTP", 'error', 5000);
    }*/
  } catch (error) {
    return {
      isOk: false,
      //message: "Failed to create account"
      message: error.response.data.message,
    };
  }
}

export async function changePassword(email, recoveryCode) {
  try {
    // Send request
    console.log(email, recoveryCode);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to change password"
    }
  }
}

export async function resetPassword(email) {
  try {
    // Send request
    console.log(email);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to reset password"
    };
  }
}
